<template>
    <div class="mx-3">
        <delete-confirmation name="user" @confirm="deleteUser"></delete-confirmation>
        <div class="d-flex justify-content-between align-items-end">
            <h2>{{ customer ? customer.name : '' }} Users</h2>
            <div class="btn-toolbar mb-2" role="toolbar">
                <div class="input-group ml-auto mt-auto mr-3">
                    <div class="input-group-prepend">
                        <div class="input-group-text"><i class="fas fa-search fa-lg text-muted"></i></div>
                    </div>
                    <input type="text" class="form-control" placeholder="Search" v-model="searchString">
                </div>
                <div class="btn-group">
                    <a :href="hrefAdd" class="btn btn-primary" title="Add User"><i class="fas fa-user-plus fa-lg"></i></a>
                </div>
            </div>
        </div>
        <div v-if="isLoading" class="pt-3 border-top">
            <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
        </div>
        <div v-else-if="filteredUsers.length" class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th class="fit"></th>
                        <th>Name</th>
                        <th>Role</th>
                        <th v-if="!customer">Customer</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th class="text-center">Signature</th>
                        <th class="text-center">Email Verified</th>
                        <th>Last Login</th>                     
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in filteredUsers" :key="'users-' + user.id">
                        <td class="fit"><i v-if="user.is_disabled" class="fas fa-ban fa-lg text-danger"></i></td>
                        <td>{{ user.full_name }}</td>
                        <td>{{ user.roles.length ? user.roles[0].name : 'Role Not Set' }}</td>
                        <td v-if="!customer">{{ user.customer ? user.customer.name : '' }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.mobile_phone|telephone }}</td>
                        <td class="text-center"><i :class="['fa', user.signature ? 'fa-check fa-lg text-success' : 'fa-times fa-lg text-danger']"></i></td>
                        <td class="text-center"><i :class="['fa', user.email_verified_at ? 'fa-check fa-lg text-success' : 'fa-times fa-lg text-danger']"></i></td>
                        <td>{{ user.last_login_at|localizeTime('YYYY-MM-DD HH:mm') }}</td>
                        <td  class="fit text-right">
                            <div class="d-flex flex-nowrap flex-row justify-content-end">
                                <a class="mr-3" :href="hrefEdit(user.id)"><i class="fas fa-edit fa-lg"></i></a>
                                <a v-if="user.can_delete" class="mr-3" @click="confirmDelete(user.id)"><i class="fas fa-trash-alt fa-lg"></i></a>
                                <i v-else class="fas fa-fw fa-lg mr-2"></i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>            
        </div>
        <div v-else class="pt-3 border-top">
            <h2 class="text-muted text-center">No active users.</h2>
        </div>  
    </div>
</template>

<script>
export default {
    props: {
        customer: Object
    },
    data() {
        return {
            isLoading: false,
            searchString: '',
            users: []
        }
    },
    computed: {
        filteredUsers: function () {
            return this.users.filter(x => 
                ((x.first_name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1) ||
                 (x.last_name.toLowerCase().indexOf(this.searchString.toLowerCase()) !== -1)));
        },
        hrefAdd: function () {
            return this.customer ? '/admin/customers/' + this.customer.id + '/users/create' : '/admin/users/create';
        }
    },
    methods: {
        refresh: function () {

            this.isLoading = true;
            let url = '/ajax/admin/users' + (this.customer ? ('/' + this.customer.id) : '');
            axios.get(url)
                .then(response => {
                    this.users = response.data.users;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    console.log(error);
                });
        },
        confirmDelete: function (id) {
            eventHub.$emit('show-delete-user-confirmation', id);
        }, 
        deleteUser: function (id) {
            axios.delete('/ajax/admin/users/' + id)
                .then(response => {

                    if (response.data.message) {

                        let level = response.data.level;
                        let title = response.data.title;
                        let message = response.data.message;
                        let timeout = response.data.timeout;
                        toastr[level](message, title, {timeOut: timeout, positionClass: "toast-top-full-width", closeButton: true}); 
                    }

                    this.refresh();                    
                })
                .catch(error => {
                    let level = error.response.data.level;
                    let title = error.response.data.title;
                    let message = error.response.data.message;
                    toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
                });                
        },
        hrefEdit: function (id) {
            return this.customer ? '/admin/customers/' + this.customer.id + '/users/' + id + '/edit' : '/admin/users/' + id + '/edit';
        }
    },
    created() {
        this.refresh();
    }
}
</script>

<style scoped>

</style>